export function IllustrationSourcingOpaque({ className }: { className?: string }) {
  return (
    <img
      className={className}
      src="/images/atelier-sourcing.webp"
      alt="Smartphones en attente de reconditionnement"
      loading="lazy"
      style={{ borderRadius: 'var(--radius-md)', objectFit: 'cover' }}
    />
  );
}
